import { apiJson } from "../utils/api.js";
import { handleApiError } from "../utils/errorHandler.js";

/**
 * Fetch available days for chef schedule
 * @param {Object} data - Schedule data
 * @returns {Promise<Object>} Available days data
 */
export const fetchAvailableDays = async (data) => {
    try {
        const response = await apiJson.post(`/kms/chef/available/days`, data);
        return response.data;
    } catch (error) {
        handleApiError(error, {
            defaultMessage: "Error: 3001: Ընտրված օրը անվավեր է: Խնդրում ենք ստուգել ընտրությունը և փորձել կրկին, կամ դիմել աջակցության բաժինը:"
        });
        throw error;
    }
};

/**
 * Fetch exception days for chef schedule
 * @param {Object} data - Exception days data
 * @returns {Promise<Object>} Exception days data
 */
export const fetchExceptionDays = async (data) => {
    try {
        const response = await apiJson.post(`/kms/chef/available/exception-days`, data);
        return response.data;
    } catch (error) {
        // Extract specific error information
        const errorCode = error.response?.data?.code;
        const errorMessage = error.response?.data?.message || error.response?.data?.developerMessage;
        
        // Provide more specific error messages based on error code
        let defaultMessage = "Error: 3001: Բացառության օրը անվավեր է կամ չի գտնվել: Խնդրում ենք ստուգել ամսաթիվը և փորձել կրկին, կամ դիմել աջակցության բաժինը:";
        
        if (errorCode === 100006 || errorMessage?.includes('invalid-chef-exceptional-day')) {
            defaultMessage = "Error: 100006: Անվավեր բացառության օր: Ամսաթիվը կարող է արդեն նշված լինել որպես բացառություն կամ անվավեր լինել: Խնդրում ենք ստուգել ամսաթիվը և փորձել կրկին:";
        } else if (errorMessage) {
            // Use backend error message if available
            defaultMessage = errorMessage;
        }
        
        handleApiError(error, {
            defaultMessage,
            showToast: false // Let the component handle the toast with translated message
        });
        throw error;
    }
};

/**
 * Delete an exception day
 * @param {string} exceptionDayId - Exception day ID
 * @returns {Promise<Object>} Delete response
 */
export const deleteExceptionDay = async (exceptionDayId) => {
    try {
        const response = await apiJson.delete(`/kms/chef/available/exception-day/${exceptionDayId}`);
        return response;
    } catch (error) {
        handleApiError(error, {
            defaultMessage: "Error: 3002: Տեղի է ունեցել սխալ, խնդրում ենք փորձել մի փոքր ուշ"
        });
        throw error;
    }
};
